<script>
import Vue from 'vue';
import { TweenLite, Cubic } from 'gsap';

export default {
	props: ['link', 'text', 'active'],
	data() {
		return {
			open: this.active,
		};
	},
	mounted() {
		// if anchor inside wrapper has class open
		// set the open property to true.
		// this secures our animation is correct
		Vue.nextTick(() => {
			if (this.$el.firstElementChild.className.indexOf('active') !== -1) {
				this.open = true;
				this.$el.nextElementSibling.classList.add('active');
			}
		});
	},
	methods: {
		toggle() {
			const el = this.$el.nextElementSibling;

			if (this.open) {
				this.open = false;

				TweenLite.to(el, 0.3, {
					height: 0,
					ease: Cubic.easeInOut,
				});
			} else {
				this.open = true;

				TweenLite.set(el, {
					height: 'auto',
					immediateRender: true,
				});

				TweenLite.from(el, 0.3, {
					height: 0,
					ease: Cubic.easeInOut,
				});
			}
		},
	},
};
</script>

<template src="./ge-menu-toggle.html"></template>
<style src="./ge-menu-toggle.scss"></style>



// WEBPACK FOOTER //
// ge-menu-toggle.vue?08602ee1